import React from 'react';
import Footer from '../../components/Footer';

interface Feature {
  icon: string;
  title: string;
  description: string;
}

const FEATURES: Feature[] = [
  {
    icon: '⏱',
    title: 'Set your limit',
    description: 'Pick the apps you want to watch and how long is too long. That\'s it.',
  },
  {
    icon: '🧠',
    title: 'Context-aware nudges',
    description: 'Messages change based on how far over your limit you are, what time it is, and how you\'ve been responding.',
  },
  {
    icon: '🔓',
    title: 'You\'re still in control',
    description: 'We don\'t block you. We just make you pause. Some social media is fine — it\'s the hour you didn\'t mean to spend.',
  },
];

function FeatureCard({ icon, title, description }: Feature) {
  return (
    <div className="feature-card">
      <div className="feature-icon">{icon}</div>
      <h3>{title}</h3>
      <p>{description}</p>
    </div>
  );
}

function HomePage() {
  return (
    <main className="home-page">
      <div className="hero-bloom" />
      <section className="hero">
        <div className="hero-left">
          <h1 className="hero-headline">
            <span className="line">Same nudge</span>
            <span className="line">every time?</span>
            <span className="line muted">Your brain tunes it out.</span>
            <span className="line">
              Hold On <span className="accent">keeps it fresh.</span>
            </span>
          </h1>
          <p className="hero-sub">
            Set your limit. We stay out of your way — until you're close.
            Then we step in with something you might actually read.
          </p>
          <div className="hero-ctas">
            <a
              href="https://apps.apple.com/in/app/holdon-screen-time-nudge/id6760806947"
              className="btn-store btn-appstore"
              target="_blank"
              rel="noopener noreferrer"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
              </svg>
              Download on App Store
            </a>
          </div>
        </div>
        <div className="hero-right">
          <div className="phone-mockup">
            <video
              className="phone-video"
              src="/videos/midscroll_nudge.mp4"
              autoPlay
              loop
              muted
              playsInline
              preload="auto"
              aria-hidden="true"
            />
            <div className="phone-notch" />
          </div>
        </div>
      </section>

      <section className="features">
        {FEATURES.map((feature) => (
          <FeatureCard
            key={feature.title}
            icon={feature.icon}
            title={feature.title}
            description={feature.description}
          />
        ))}
      </section>

      <Footer />
    </main>
  );
}

export default HomePage;
